// @ts-nocheck

export const localeCodes =  [
  "zh-CN",
  "en",
  "ja"
]
export const localeLoaders = {
  "zh-CN": [
    {
      key: "locale_zh_45CN_46json_32f854db",
      load: () => import("#nuxt-i18n/32f854db" /* webpackChunkName: "locale_zh_45CN_46json_32f854db" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => import("#nuxt-i18n/0b63539c" /* webpackChunkName: "locale_en_46json_0b63539c" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_fd6e2db5",
      load: () => import("#nuxt-i18n/fd6e2db5" /* webpackChunkName: "locale_ja_46json_fd6e2db5" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]
export const normalizedLocales = [
  {
    code: "zh-CN",
    name: "简体中文",
    language: "zh-CN"
  },
  {
    code: "en",
    name: "English",
    language: "en-US"
  },
  {
    code: "ja",
    name: "日本語",
    language: "ja-JP"
  }
]

